import { Component, OnInit, Inject } from '@angular/core';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { PatientTrackingModel } from '../Models/patient_tracking.model';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LanguageService } from 'app/shared/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExportService } from 'app/reports/services/export.service';

export interface DialogData {
  patientid: string;
  // name: string;
}

@Component({
  selector: 'app-patient_tracking',
  templateUrl: './patient_tracking.component.html',
  styleUrls: ['./patient_tracking.component.scss']
})
export class Patient_trackingComponent implements OnInit {
  destroytranking$: Subject<boolean> = new Subject<boolean>();
  private visitselected = -1;

  displayedColumns: string[] = ['UHID', 'visitdate', 'FromLoc', 'EnteredBy', 'UserRole', 'Action', 'EntryDate', 'EntryTime'];
  private tracking_details: PatientTrackingModel[] = [];
  private dataSource;
  private firstvisitdate;
  private visitArray: any = [];
  constructor(public opdVisitService: OpdVisitService,
    private http: HttpClient, private dashBoardService: DashboardService, private dialogRef: MatDialogRef<Patient_trackingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public langservice: LanguageService,
    private translate: TranslateService,private exportdata: ExportService,
    private datePipe: DatePipe) {
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
  }

  ngOnInit() {
    this.tracking_details = [];
    this.visitArray = this.opdVisitService.visitdates.filter((el, i, a) => i === a.indexOf(a.find(f => this.datePipe.transform(f.visitDate, "yyyy-MM-dd") === this.datePipe.transform(el.visitDate, "yyyy-MM-dd"))));
    this.firstvisitdate = this.datePipe.transform(this.visitArray[0].visitDate, "yyyy-MM-dd");

    this.visitselected = this.visitArray[0].fK_VisitId;
    this.get_patient_tracking(this.firstvisitdate);

    //console.log("patid: " + this.data.patientid);

  }
  ngOnDestroy() {
    this.destroytranking$.next(true);
    this.destroytranking$.unsubscribe();
    this.visitArray = null;
    this.firstvisitdate = null;
    this.visitselected = null;
    this.tracking_details = null;
  }
  // formattime(trackingtime: string) {
  //   if (trackingtime == null) {
  //     // do nothing
  //     //09:30:00.000000
  //   }
  //   else {
  //     // "12:10:00.0000000"
  //     var hr_min_sec = trackingtime.split(".", 2);
  //     var hr_min = hr_min_sec[0].split(":", 3);
  //     // return hr_min[0] + ":" + hr_min[1];



  //     if (+hr_min[0] == 12 && +hr_min[1] == 0o0) {
  //       console.log("app time " + hr_min[0]);
  //       return hr_min[0] + ":" + "00" + " pm";
  //     }

  //     else if (+hr_min[0] < 12) {
  //       return hr_min[0] + ":" + hr_min[1] + " am";
  //     }
  //     else {
  //       if (+hr_min[0] == 12) {
  //         return +hr_min[0] + ":" + hr_min[1] + " pm";

  //       }

  //       else if (+hr_min[0] - 12 <= 9) {
  //         return ("0") + (+hr_min[0] - 12) + ":" + hr_min[1] + " pm";
  //       }
  //       else {
  //         return (+hr_min[0] - 12) + ":" + hr_min[1] + " pm";
  //       }

  //     }
  //   }
  // }


  formattime(trackingtime: string) {
    if (trackingtime == null) {
      return '';
    }
    else {
      var hr_min_sec = trackingtime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
  
      return hr_min[0] + ":" + hr_min[1]; // 24-hour format, no AM/PM
    }
  }
  
  get_patient_tracking(firstvisitdate: string) {

    this.dashBoardService.getPatientracking(this.data.patientid, firstvisitdate).pipe(takeUntil(this.destroytranking$))
      .subscribe(
        data => this.success_trackdetails(data), err => this.failed_trackdetails(err)
      )
  }
  success_trackdetails(data) {
    this.tracking_details = data;
    this.dataSource = this.tracking_details;
  }
  failed_trackdetails(err) {
    if (err.status == 403) {
      this.dashBoardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashBoardService.openSnackBar("API Failed", "OK");
    }
  }

  filtertracking(visitid: number) {

    this.visitselected = visitid;
    const visitdate = this.opdVisitService.visitdates.find(item => item.fK_VisitId == visitid).visitDate;
    const convertdate = this.datePipe.transform(visitdate, "yyyy-MM-dd");

    this.get_patient_tracking(convertdate);

    console.log("visit id " + visitid);
  }
  keyDownFunction(event) {

    if (event.keyCode === 27) {
      this.visitArray = [];
      this.dialogRef.close();
    }

  }
  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('opdtrackingcontent');
    this.exportdata.Newexportxcel(element, 'OPD Tracking List');

  }
}
